export const GET_PROPERTY_DETAIL = 'GET_PROPERTY_DETAIL';
export const GET_SELFT_PROPERTY_LISTING = 'GET_SELFT_PROPERTY_LISTING';
export const GET_RENTED_PROPERTIES = 'GET_RENTED_PROPERTIES';
export const GET_SALE_PROPERTIES = 'GET_SALE_PROPERTIES';
export const GET_RELATED_PROPERTIES = 'GET_RELATED_PROPERTIES';
export const GET_FEATURED_PROPERTIES = 'GET_FEATURED_PROPERTIES';
export const GET_FEATURED_PROPERTIES_WITH_PAGINATION = 'GET_FEATURED_PROPERTIES_WITH_PAGINATION';
export const GET_LATEST_PROPERTIES_WITH_PAGINATION = 'GET_LATEST_PROPERTIES_WITH_PAGINATION';
export const SEARCH_PROPERTIES = 'SEARCH_PROPERTIES';
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';